import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/noData_empty.svg'


const _hoisted_1 = { class: "flex justify-between items-center px-6 py-4 border-b border-gray-200" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-xl font-semibold text-black-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "x"
}, null, -1)
const _hoisted_5 = {
  class: "flex flex-col gap-y-4 overflow-y-auto",
  style: {"width":"578px","max-height":"514px"}
}
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2"
}
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "text-base font-semibold text-red-lp-100" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2"
}
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = { class: "text-base font-semibold text-red-lp-100" }
const _hoisted_13 = { class: "font-normal" }
const _hoisted_14 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_15 = { class: "font-medium" }
const _hoisted_16 = { class: "text-base font-semibold" }
const _hoisted_17 = {
  key: 0,
  class: "flex w-full"
}
const _hoisted_18 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, " Total STT ", -1)
const _hoisted_20 = { class: "text-base font-semibold" }
const _hoisted_21 = { class: "font-normal" }
const _hoisted_22 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_23 = { class: "font-medium" }
const _hoisted_24 = { class: "text-base font-semibold" }
const _hoisted_25 = {
  key: 1,
  class: "flex w-full"
}
const _hoisted_26 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_27 = { class: "font-medium" }
const _hoisted_28 = { class: "text-base font-semibold break-all" }
const _hoisted_29 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_30 = { class: "font-medium" }
const _hoisted_31 = { class: "text-base font-semibold break-all" }
const _hoisted_32 = {
  key: 2,
  class: "flex w-full"
}
const _hoisted_33 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_34 = { class: "font-medium" }
const _hoisted_35 = { class: "text-base font-semibold break-all" }
const _hoisted_36 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700 w-1/2" }
const _hoisted_37 = { class: "font-medium" }
const _hoisted_38 = { class: "text-base font-semibold break-all" }
const _hoisted_39 = { class: "flex flex-col gap-y-1 text-sm text-gray-lp-2700" }
const _hoisted_40 = { class: "font-medium" }
const _hoisted_41 = {
  key: 0,
  class: "flex flex-wrap gap-3"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 3,
  class: "flex flex-col items-center justify-center gap-y-2 py-8"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-40",
  alt: "no data"
}, null, -1)
const _hoisted_45 = { class: "text-center text-gray-lp-600 text-sm" }
const _hoisted_46 = {
  key: 4,
  class: "rounded-xl border border-gray-lp-1400 w-full"
}
const _hoisted_47 = { class: "bg-gray-lp-1000 rounded-xl w-full text-black-lp-300 text-sm" }
const _hoisted_48 = { class: "font-bold" }
const _hoisted_49 = { class: "p-4 text-left" }
const _hoisted_50 = { class: "p-4 text-left" }
const _hoisted_51 = { class: "p-4 text-left" }
const _hoisted_52 = {
  key: 0,
  class: "p-4 text-center"
}
const _hoisted_53 = { class: "p-4 text-left" }
const _hoisted_54 = {
  key: 1,
  class: "p-4 text-center"
}
const _hoisted_55 = { class: "bg-white" }
const _hoisted_56 = { class: "p-4" }
const _hoisted_57 = { class: "p-4" }
const _hoisted_58 = {
  key: 0,
  class: "p-4"
}
const _hoisted_59 = { class: "flex items-center justify-center" }
const _hoisted_60 = { class: "p-4" }
const _hoisted_61 = {
  key: 1,
  class: "p-4"
}
const _hoisted_62 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PreviewImagePod = _resolveComponent("PreviewImagePod")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
      customBody: "p-4 px-6"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.depositIn", { type: _ctx.typeDeposit })), 1)
          ]),
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
          }, [
            _hoisted_4
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            (_ctx.isMoneyDeposit)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.nominalUang")), 1),
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.formatByCountry(_ctx.data.totalAmount, { type: "money", prefix: _ctx.prefixCurrency })), 1)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.totalStt")), 1),
                  _createVNode("span", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.data.totalPackage) + " STT ", 1),
                    _createVNode("span", _hoisted_13, " (" + _toDisplayString(_ctx.data.totalPiece) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                  ])
                ])),
            _createVNode("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("codReconcile.detail.tanggal")), 1),
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.formattedDate), 1)
            ])
          ]),
          (_ctx.isMoneyDeposit)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("span", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.data.totalPackage) + " STT ", 1),
                    _createVNode("span", _hoisted_21, " (" + _toDisplayString(_ctx.data.totalPiece) + " koli) ", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("codReconcile.detail.paymentMethod")), 1),
                  _createVNode("span", _hoisted_24, _toDisplayString(_ctx.data.paymentMethod || "-"), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isMoneyDeposit)
            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("codReconcile.detail.namaPenerima")), 1),
                  _createVNode("span", _hoisted_28, _toDisplayString(_ctx.data.recipientName || "-"), 1)
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("codReconcile.detail.depositLocation")), 1),
                  _createVNode("span", _hoisted_31, _toDisplayString(_ctx.data.recipientLocation || "-"), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isMoneyDeposit)
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("codReconcile.detail.depositLocation")), 1),
                  _createVNode("span", _hoisted_35, _toDisplayString(_ctx.data.recipientLocation || "-"), 1)
                ]),
                _createVNode("div", _hoisted_36, [
                  _createVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("codReconcile.detail.namaPenerima")), 1),
                  _createVNode("span", _hoisted_38, _toDisplayString(_ctx.data.recipientName || "-"), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_39, [
            _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.buktiFoto")), 1),
            (_ctx.data.photos?.length)
              ? (_openBlock(), _createBlock("div", _hoisted_41, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.photos, (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "p-1 rounded-lg bg-gray-lp-1000 flex items-center justify-center cursor-pointer",
                      style: {"height":"50px","width":"50px"}
                    }, [
                      _createVNode("img", {
                        src: item.url,
                        class: "w-full h-full object-cover rounded-lg",
                        alt: `Bukti foto perubahan berat koli ${index + 1}`,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)))
                      }, null, 8, ["src", "alt"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_42, "-"))
          ]),
          (!_ctx.data.stt.length)
            ? (_openBlock(), _createBlock("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.noData")), 1)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_46, [
                _createVNode("table", _hoisted_47, [
                  _createVNode("thead", _hoisted_48, [
                    _createVNode("th", _hoisted_49, _toDisplayString(_ctx.$t("codReconcile.list.no")), 1),
                    _createVNode("th", _hoisted_50, _toDisplayString(_ctx.isMoneyDeposit ? _ctx.$t("codReconcile.dailyDeposit.noStt") : _ctx.$t("codReconcile.dailyDeposit.noSttShipment")), 1),
                    _createVNode("th", _hoisted_51, _toDisplayString(_ctx.isMoneyDeposit ? _ctx.$t("codReconcile.dailyDeposit.layanan") : _ctx.$t("codReconcile.detail.statusSetoran")), 1),
                    (_ctx.isMoneyDeposit)
                      ? (_openBlock(), _createBlock("th", _hoisted_52, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.successSetor")), 1))
                      : _createCommentVNode("", true),
                    _createVNode("th", _hoisted_53, _toDisplayString(_ctx.isMoneyDeposit ? _ctx.$t("codReconcile.dailyDeposit.nominal") : _ctx.$t("codReconcile.dailyDeposit.amount")), 1),
                    (!_ctx.isMoneyDeposit)
                      ? (_openBlock(), _createBlock("th", _hoisted_54, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.successSetor")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("tbody", _hoisted_55, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.stt, (item, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: index,
                        class: "border-t border-gray-lp-1400"
                      }, [
                        _createVNode("td", {
                          class: ["p-4", {
                  'rounded-bl-xl': index === _ctx.data.stt.length - 1
                }]
                        }, _toDisplayString(index + 1), 3),
                        _createVNode("td", _hoisted_56, _toDisplayString(item.sttNo), 1),
                        _createVNode("td", _hoisted_57, _toDisplayString(_ctx.isMoneyDeposit ? item.codType : item.lastStatus), 1),
                        (_ctx.isMoneyDeposit)
                          ? (_openBlock(), _createBlock("td", _hoisted_58, [
                              _createVNode("div", _hoisted_59, [
                                _createVNode("img", {
                                  src: 
                      item.isReconciled
                        ? require('@/app/ui/assets/svg/ics_f_check_circle.svg')
                        : require('@/app/ui/assets/svg/ics_f_min_circle.svg')
                    ,
                                  class: "w-7 h-7",
                                  alt: "check"
                                }, null, 8, ["src"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("td", _hoisted_60, _toDisplayString(_ctx.isMoneyDeposit
                    ? _ctx.formatByCountry(item.totalAmount, { type: "money", prefix: _ctx.prefixCurrency })
                    : item.totalPiece), 1),
                        (!_ctx.isMoneyDeposit)
                          ? (_openBlock(), _createBlock("td", _hoisted_61, [
                              _createVNode("div", _hoisted_62, [
                                _createVNode("img", {
                                  src: 
                      item.isReconciled
                        ? require('@/app/ui/assets/svg/ics_f_check_circle.svg')
                        : require('@/app/ui/assets/svg/ics_f_min_circle.svg')
                    ,
                                  class: "w-7 h-7",
                                  alt: "check"
                                }, null, 8, ["src"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.isPreviewPhotos)
      ? (_openBlock(), _createBlock(_component_PreviewImagePod, {
          key: 0,
          data: _ctx.previewPhotos,
          onClose: _ctx.onClosePreview
        }, null, 8, ["data", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}